/* import __COLOCATED_TEMPLATE__ from './section.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
import { trackedReset } from 'tracked-toolbox';
import { action } from '@ember/object';
import { type InspectItem } from './inspect-sections';

interface SectionComponentArgs {
  questionId?: number;
  sectionId: string;
  items: InspectItem[];
  title: string;
}

type SectionComponentSignature = {
  Args: SectionComponentArgs;
  Element: HTMLDivElement;
};

export default class Section extends Component<SectionComponentSignature> {
  @trackedReset('args.questionId') openSectionId = '';
  @trackedReset('args.questionId') viewingAllItems = false;

  get firstThreeItems() {
    return this.args.items?.slice(0, 3);
  }

  get remainingItems() {
    return this.args.items?.slice(3);
  }

  @action toggleSection() {
    let sectionId = this.args.sectionId;
    let isOpen = this.openSectionId === sectionId;
    this.openSectionId = isOpen ? '' : sectionId;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::FinAnswer::Inspect::Section': typeof Section;
  }
}
